export const getTextLength = (node: any): number => {
  if (!node || typeof node !== 'object') return 0;

  let length = 0;

  // Если узел содержит `text`, считаем его длину
  if ('text' in node && typeof node.text === 'string') {
    length += node.text.length;
  }

  // Обрабатываем дочерние узлы, если есть
  if (Array.isArray(node.content)) {
    for (const child of node.content) {
      length += getTextLength(child);
    }
  }

  return length;
}

/** Плоский текст TipTap-документа (объект или JSON-строка); битый ввод → "". */
export const getPlainText = (content: unknown): string => {
  let root: unknown = content;
  if (typeof content === "string") {
    try {
      root = JSON.parse(content);
    } catch {
      return "";
    }
  }

  const parts: string[] = [];
  const walk = (node: unknown) => {
    if (!node || typeof node !== "object") return;
    const n = node as { type?: string; text?: string; content?: unknown[] };
    if (typeof n.text === "string") parts.push(n.text);
    if (n.type === "hardBreak") parts.push(" ");
    if (Array.isArray(n.content)) {
      n.content.forEach(walk);
      parts.push(" ");
    }
  };
  walk(root);

  return parts.join("").replace(/\s+/g, " ").trim();
};

/**
 * DEV-604: у постов нет заголовка — для SEO, шаринга и аналитики берём
 * выдержку из текста: обрезка по границе слова + «…».
 */
export const getPostExcerpt = (content: unknown, max = 80): string => {
  const text = getPlainText(content);
  if (text.length <= max) return text;

  const cut = text.slice(0, max);
  const lastSpace = cut.lastIndexOf(" ");
  const base = lastSpace > max / 2 ? cut.slice(0, lastSpace) : cut;
  return `${base.replace(/[\s,;:.!?-]+$/g, "")}…`;
};
